module.exports = __webpack_public_path__ + "static/img/200044.a9139bfe.png";